// ═══════════════════════════════════════════════════════════════════════
// Dispositifs sociaux — routes web (ARCHITECTURE_CONSTRUCTION.md § 2.3), insérées dans App.jsx par
// {routesDispositifs()}. Toute personne connectée (hors prestataire externe) peut ouvrir ces adresses :
// le serveur décide ce qu'elle voit (mandat en cours ou clé transverse) et refuse le reste (403 affiché).
// « Instances et mandats », jamais « Gouvernance » (collision avec /gouvernance).
// /dispositifs/controle-carte : contrôle de la carte employé (permission controler_cartes_employes) ; segment fixe,
// prioritaire sur /dispositifs/:org.
// ═══════════════════════════════════════════════════════════════════════
import { Navigate, Route, useParams } from 'react-router-dom';
import { Protege } from './commun';
import EspacesPage from './EspacesPage';
import OrganisationPage from './OrganisationPage';
import DispositifPage from './DispositifPage';
import PretPage from './PretPage';
import AidePage from './AidePage';
import { CreancePage, PaiementPage } from './FinanceFiches';
import CampagnePage from './CampagnePage';
import ControleCartePage from './carte/ControleCarte';

function VersInstances() {
  const { org } = useParams();
  return <Navigate to={`/dispositifs/${org}/instances`} replace />;
}

const SECTIONS = ['instances', 'dispositifs', 'a-traiter', 'historique', 'pieces', 'prets', 'aides', 'campagnes', 'tresorerie', 'comptabilite', 'retenues', 'rapports'];

export function routesDispositifs() {
  return (
    <>
      <Route path="/dispositifs" element={<Protege><EspacesPage /></Protege>} />
      <Route path="/dispositifs/controle-carte" element={<Protege><ControleCartePage /></Protege>} />
      <Route path="/dispositifs/:org" element={<Protege><VersInstances /></Protege>} />
      {SECTIONS.map((s) => (
        <Route key={s} path={`/dispositifs/:org/${s}`} element={<Protege><OrganisationPage section={s} /></Protege>} />
      ))}
      <Route path="/dispositifs/:org/dispositifs/:id" element={<Protege><DispositifPage /></Protege>} />
      <Route path="/dispositifs/:org/prets/:id" element={<Protege><PretPage /></Protege>} />
      <Route path="/dispositifs/:org/aides/:id" element={<Protege><AidePage /></Protege>} />
      <Route path="/dispositifs/:org/campagnes/:id" element={<Protege><CampagnePage /></Protege>} />
      <Route path="/dispositifs/:org/tresorerie/creances/:id" element={<Protege><CreancePage /></Protege>} />
      <Route path="/dispositifs/:org/tresorerie/paiements/:id" element={<Protege><PaiementPage /></Protege>} />
    </>
  );
}

export default routesDispositifs;
